import React from 'react';

export default function Footer() {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{
      background: '#080807',
      borderTop: '1px solid rgba(201,168,76,0.08)',
      padding: '60px 5% 40px',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 48,
          marginBottom: 60,
        }}>
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <span style={{ fontSize: 28, color: '#E8732A' }}>ॐ</span>
              <div>
                <div style={{ fontFamily: 'Cinzel', fontSize: 16, color: '#F5F0E8', letterSpacing: 2 }}>VEDIC IT</div>
                <div style={{ fontSize: 9, color: '#C9A84C', letterSpacing: 2, textTransform: 'uppercase' }}>Clarity Before Code</div>
              </div>
            </div>
            <p style={{ color: '#6B6560', fontSize: 13, lineHeight: 1.8, maxWidth: 240 }}>
              Blending ancient wisdom with modern technology. Operating under Sri Arunachala Services Initiative.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 style={{ fontFamily: 'Cinzel', fontSize: 12, letterSpacing: 3, color: '#C9A84C', textTransform: 'uppercase', marginBottom: 20 }}>
              Navigation
            </h4>
            {['home', 'about', 'services', 'principles', 'insights', 'contact'].map(link => (
              <button
                key={link}
                onClick={() => scrollTo(link)}
                style={{
                  display: 'block',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#6B6560',
                  fontSize: 13,
                  textTransform: 'capitalize',
                  marginBottom: 10,
                  letterSpacing: 1,
                  textAlign: 'left',
                  padding: 0,
                  transition: 'color 0.2s',
                }}
                onMouseEnter={e => e.target.style.color = '#B0A898'}
                onMouseLeave={e => e.target.style.color = '#6B6560'}
              >
                {link}
              </button>
            ))}
          </div>

          {/* Services */}
          <div>
            <h4 style={{ fontFamily: 'Cinzel', fontSize: 12, letterSpacing: 3, color: '#C9A84C', textTransform: 'uppercase', marginBottom: 20 }}>
              Services
            </h4>
            {['IT Consulting', 'Product Development', 'AI & Automation', 'Digital Marketing', 'Business Transformation', 'Tech Festivals'].map(s => (
              <div key={s} style={{ color: '#6B6560', fontSize: 13, marginBottom: 10, letterSpacing: 0.5 }}>
                {s}
              </div>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontFamily: 'Cinzel', fontSize: 12, letterSpacing: 3, color: '#C9A84C', textTransform: 'uppercase', marginBottom: 20 }}>
              Contact
            </h4>
            <a href="mailto:info@vedicit.org" style={{ display: 'block', color: '#6B6560', fontSize: 13, marginBottom: 10, textDecoration: 'none', letterSpacing: 0.5 }}>
              info@vedicit.org
            </a>
            <a href="tel:+919611701326" style={{ display: 'block', color: '#6B6560', fontSize: 13, marginBottom: 10, textDecoration: 'none', letterSpacing: 0.5 }}>
              +91 9611701326
            </a>
            <div style={{ fontSize: 12, color: '#4a4540', marginTop: 16, lineHeight: 1.6 }}>
              Sri Arunachala Services Initiative<br />
              80G Non-Profit Registration
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(201,168,76,0.06)',
          paddingTop: 32,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 16,
        }}>
          <div style={{ fontSize: 12, color: '#4a4540', letterSpacing: 0.5 }}>
            © 2025 Vedic IT · Sri Arunachala Services Initiative · All rights reserved
          </div>
          <div style={{ fontFamily: 'Cinzel', fontSize: 14, color: 'rgba(201,168,76,0.2)', letterSpacing: 2 }}>
            सत्यं शिवं सुंदरम्
          </div>
        </div>
      </div>
    </footer>
  );
}
